<template>
  <div class="topPart">
    <img src="../assets/images/news.png" alt="" />
    <span>暂无最新消息</span>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
  .topPart {
    width: 100%;
    display: flex;
    height: 40px;
    background: #fff;
    box-sizing: border-box;
    padding: 10px 20px;
    font-size: 14px;
    border-radius: 6px;
    align-items: center;
    img {
      width: 12px;
      height: 12px;
      margin-right: 6px;
    }
  }
</style>